<template>
  <div class="spinner-root">
    <div class="spinner-animation">
      <svg
        height="50"
        stroke-width="8.00"
        viewBox="1.00 1.00 98.00 98.00"
        width="50"
      >
        <path
          :class="
            ['spinner-track'].concat(
              color ? [`spinner-track_color_${color}`] : []
            )
          "
          d="M 50,50 m 0,-45 a 45,45 0 1 1 0,90 a 45,45 0 1 1 0,-90"
        />
        <path
          :class="
            ['spinner-head'].concat(
              color ? [`spinner-head_color_${color}`] : []
            )
          "
          d="M 50,50 m 0,-45 a 45,45 0 1 1 0,90 a 45,45 0 1 1 0,-90"
          path-length="280"
          stroke-dasharray="280 280"
          stroke-dashoffset="210"
        />
      </svg>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    color: String
  },
  setup(props: object) {
    return { ...(props as { color?: string }) };
  }
};
</script>

<style lang="scss">
@import "../assets/styles/spinner.scss";
</style>
